import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStripeComponent } from './simple-icons-stripe.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStripeComponent ],
    exports:      [ SimpleIconsStripeComponent ],
    bootstrap:    []
})
export class SimpleIconsStripeModule {}
